import { ContractEstimate } from '../../api/get-contract-estimate'

export const CONTRACT_ESTIMATE: ContractEstimate = {
  week: 1,
  startDate: '2025-07-21',
  endDate: '2025-07-27',
  usingFee: 330000,
  longTermDiscount: 0,
  earlyDiscount: 0,
  mgmtFee: 30000,
  cleanFee: 50000,
  contractFee: 40590,
  realUsingFee: 450590,
  deposit: 330000,
  finalPayFee: 780590,
  refundTerms: [
    {
      fromDate: null,
      toDate: '2025-05-28',
      fromDateDiffDays: null,
      toDateDiffDays: 15,
      cancelFeePercent: 0,
    },
    {
      fromDate: '2025-05-29',
      toDate: '2025-06-04',
      fromDateDiffDays: 14,
      toDateDiffDays: 8,
      cancelFeePercent: 20,
    },
    {
      fromDate: '2025-06-05',
      toDate: '2025-06-11',
      fromDateDiffDays: 7,
      toDateDiffDays: 1,
      cancelFeePercent: 40,
    },
    {
      fromDate: '2025-06-12',
      toDate: null,
      fromDateDiffDays: 0,
      toDateDiffDays: null,
      cancelFeePercent: null,
    },
  ],
  roomName: '테스트',
  addrLot: '서울특별시 서초구 잠원동 15-10 라성빌딩',
  addrStreet: '서울특별시 서초구 나루터로 59',
  picMain: 'room/6fa09fbc-6fd7-45bf-bc0c-edd3e60aa80c.jpg',
  hostName: '곽민아',
  hostPhoneNumber: '계약이 확정된 후 연락처가 공개됩니다.',
  guestName: '곽민아',
  guestPhoneNumber: '0101234567890',
}
